export default [{
    meta: {
        requiresAuth: true
    },
    name: 'flightGJList',
    path: '/mall/flightGJ/flightList',
    component: resolve => require(['./flightList.vue'], resolve)
},

]


// WEBPACK FOOTER //
// ./src/views/mall/flightGJ/router.js